// Redesign 2026 – video s náhledovou fotkou ([data-rd-video], markup includes/template-parts/redesign/video.php).
// Klik na fotku ji nahradí přehrávačem YouTube, který se rovnou spustí.
export default function initRedesignVideo() {
  document.querySelectorAll('[data-rd-video]').forEach((box) => {
    const button = box.querySelector('.rd-video__play');
    if (!button) {
      return;
    }
    button.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.src = box.dataset.rdVideo;
      iframe.title = box.dataset.rdVideoTitle || '';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      box.replaceChildren(iframe);
      box.classList.remove('rd-video--poster');
    }, { once: true });
  });
}
